module.exports = __webpack_public_path__ + "img/暂无数据@2x.d8fcde56.png";